import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "./button"

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--hp-color-focus)] focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-[var(--hp-color-primary)] text-[var(--hp-color-on-primary)]",
        secondary: "bg-[var(--hp-color-surface-muted)] text-[var(--hp-color-text)]",
        destructive: "bg-[var(--hp-danger-100)] text-[var(--hp-danger-700)]",
        outline: "text-[var(--hp-color-text)] border border-[var(--hp-color-border)]",
        success: "bg-[var(--hp-success-100)] text-[var(--hp-success-700)]",
        info: "bg-[var(--hp-info-100)] text-[var(--hp-info-700)]",
        warning: "bg-[var(--hp-warning-100)] text-[var(--hp-warning-700)]",
        neutral: "bg-[var(--hp-ink-100)] text-[var(--hp-ink-700)]",
        accent: "bg-[var(--hp-bronze-100)] text-[var(--hp-bronze-700)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
